var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-layout__frame c-frame",class:{
        'no-frame': !_vm.item.hasFrame,
        'u-inspectable': _vm.inspectable,
        'is-in-small-container': _vm.size.width < 600 || _vm.size.height < 600
    },style:(_vm.style)},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"c-frame__move-bar",on:{"mousedown":function($event){_vm.isEditing ? _vm.startMove([1,1], [0,0], $event) : null}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }